import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import HeroCardLayout from "../layout/HeroCardLayout";
import FloatingLabelInput from "../utils/FloatingLabelInput";
import "../../styles/components/entryflow/PatientIntake.css";

interface Props {
  onContinue: (patientNumber: string, patientFirstName: string, patientLastName: string) => void;
}

const PatientIntakeView: React.FC<Props> = ({
  onContinue,
}) => {
  const { t } = useTranslation();
  const [patientNumber, setPatientNumber] = useState("");
  const [patientFirstName, setPatientFirstName] = useState("");
  const [patientLastName, setPatientLastName] = useState("");
  
  // Button is enabled only when patientNumber and patientFirstName have at least 1 character
  const isButtonEnabled = patientNumber.length > 0 && patientFirstName.length > 0;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onContinue(patientNumber, patientFirstName, patientLastName);
  };

  return (
    <>
      <div className="patient-intake-title">{t("patientIntake.title")}</div>
      <form onSubmit={handleSubmit}>
        <div className="patient-intake-container">
          <FloatingLabelInput
            label={t("patientIntake.patientIdNumber")}
            isName={false}
            limit={50}
            type="text"
            name="patientNumber"
            value={patientNumber}
            onChange={(e) => setPatientNumber(e.target.value)}
            readOnly={false}
            required
          />
          <FloatingLabelInput
            label={t("finalizeUser.firstName")}
            isName={true}
            limit={50}
            type="text"
            name="patientFirstName"
            value={patientFirstName}
            onChange={(e) => setPatientFirstName(e.target.value)}
            readOnly={false}
            required
          />
          <FloatingLabelInput
            label={t("finalizeUser.lastName")}
            isName={true}
            limit={50}
            type="text"
            name="patientLastName"
            value={patientLastName}
            isOptional={true}
            onChange={(e) => setPatientLastName(e.target.value)}
            readOnly={false}
            required={false} // Make this optional since button doesn't require it
          />
          <button 
            type="submit" 
            className="entryflow-submit-button continue-button"
            disabled={!isButtonEnabled}
          >
            {t("finalizeUser.continue")}
          </button>
        </div>
      </form>
    </>
  );
};

const PatientIntakeViewOnly: React.FC = () => {
  return (
    <HeroCardLayout>
      <PatientIntakeView
        onContinue={(patientNumber, patientFirstName, patientLastName) => {
          console.log("Testing Patient Info:", { patientNumber, patientFirstName, patientLastName });
        }}
      />
    </HeroCardLayout>
  );
};

export default PatientIntakeView;
export { PatientIntakeViewOnly };
